(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'Bucket',
	};

	// var intervalVar;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#bucket-recipient').on('adz.typeahead.afterSelect', function selectedSomeone() {
			$('#bucket-available_in_mytrips').removeClass('disabled');
		});

		$('.recipient-selection', $form).on('adz.recipients.empty', function redisable() {
			$('#bucket-available_in_mytrips').addClass('disabled');

			$('#bucket-available_in_mytrips').prop('checked', false);
		});
	};

	form.success = function success(response)
	{
		var current_amount,
			new_amount;

		if (!Adzuki.Form.hasError(response)) {
			if ($('#bucket-id').length > 0) {
				window.location.href = response['data'];
				return true;
			}

			current_amount = $('.bucket-link a').attr('data-amount');
			new_amount     = parseInt(current_amount) + 1;

			$('.bucket-link a').attr('data-amount', new_amount);

			if ($('.bucket-add-item').length > 0) {
				Adzuki.StatusMessage('Success', 'Your bucket has been added');

				$('.bucket-new-form').addClass('hidden');
				$('.bucket-add-form').removeClass('hidden');

				if ($('.bucket-new-form').length === 0) {
					$('.modal').modal('hide');
				} else {
					// reset form
					$('#bucket-name').val();

					$('.bucket-new-form .recipients .remove-all').click();

					$('#bucketitem-bucket_id').append($('<option>', {
						value: response['data']['bucket_id'],
						text : response['data']['bucket_name']
					}));

					$('#bucketitem-bucket_id option:last').attr("selected", "selected");
				}
			} else {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Buckets/manage';
			}
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error saving type');

		return false;
	};
}(jQuery, window.Adzuki || {}));